/**
 * Created by Karol Kluska on 09.10.17.
 */
angular
  .module('app')
  .component('discountCodeDropdown', {
    templateUrl: 'app/components/bookingEngine/header/headerDropdown/DiscountCode.html',
    controller: DiscountCode,
    bindings: {
      onSave: '&'
    }
  });

/** @ngInject */
function DiscountCode(Restangular, Params, $translate) {
  var $this = this;
  $this.Restangular = Restangular;
  $this.Params = Params;
  $this.$translate = $translate;
  $this.errorDiscountCode = '';
}

DiscountCode.prototype = {
  $onInit: function () {
    this.userHash = this.Params.getUserHash();
    this.hotelId = this.Params.getHotelId();
    this.language = this.Params.getLanguage();
    this.discountCode = this.Params.getDiscountCode();
  },

  handleSave: function () {
    var $this = this;
    $this.onSave({code: $this.discountCode});
    return;

    /* eslint-disable camelcase */
    var requestParams = {
      user_id: $this.userHash,
      code_name: $this.discountCode,
      date: $this.Params.getCheckIn()
    };
    /* eslint-enable camelcase */
    $this.Restangular.all('discountcode').customGET('check', requestParams)
      .then(function () {
        $this.errorDiscountCode = '';
        
      })
      .catch(function (response) {
        if (response.status === 404) {
          $this.errorDiscountCode = $this.$translate.instant('header.discount_code.UNAVAILABLE');
        } else {
          $this.errorDiscountCode = $this.$translate.instant('header.discount_code.DOES_NOT_EXISTS');
        }
      });
  }
};
